export const extendUri = (uri: any) => (operation: any) => {
  const variables = operation.variables?.skillType ? '&' + operation.variables?.skillType : '';
  return `${uri}?${encodeURIComponent(operation.operationName)}${variables}`;
};

export const errorIsTimeout = (message: string) => message?.match(/Timeout on/gi);
